<template>
  <div class="PasswordChangeFinish">
    <section-header heading="2" ja="パスワードの変更が完了しました"/>
    <div class="text-area">本サービスにログインする際に必要な情報ですので、登録メールアドレスとパスワードを忘れないようにご注意ください。</div>
    <section-header heading="2" ja="登録メールアドレス"/>
    <div class="text-area">{{ mailAddress }}</div>
    <section-header heading="2" ja="登録パスワード"/>
    <div class="text-area">{{ securePassword }}</div>
    <normal-btn @click="onLogin">ログインする</normal-btn>
  </div>
</template>

<script>
import SectionHeader from '../components/SectionHeader'
import NormalBtn from '../components/NormalBtn'

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "PasswordChangeFinish",
  components: {
    NormalBtn,
    SectionHeader
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin
    },
    securePassword() {
      return this.$store.getters.securePassword
    },
    mailAddress() {
      return this.$store.getters.mailAddress
    },
  },
  methods: {
    onLogin() {
      if(this.islogin) {
        const cmdNo = pb.LogoutReq.CommandNo.COMMAND_NO
      const message = pb.LogoutReq.create({
        token: this.$store.getters.token
      })
      const encoded = pb.LogoutReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.LogoutResp.Status.SUCCESS) {
            this.$store.dispatch('logout')
            this.$router.push('/login')
          } else {
            this.$_error('Error', { title: 'パスワード変更', statusCode: 413 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'パスワード変更', statusCode: 100 })
        })
      } else {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.text-area {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
